import React, { useState } from 'react'
import styled from 'styled-components'
import useMediaQuery from 'src/Utils/useMediaQuery'
import Rocket from 'src/Animations/SpeedCheckRunAnimation'
import RocketInfinite from 'src/Animations/SpeedCheckInfiniteAnimation'

const bigSize = 240
const mediumSize = 200
const smallSize = 180

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;

  @media (min-width: 320px) {
    width: ${smallSize}px;
    height: ${smallSize}px;
  }

  @media (min-width: 768px) {
    width: ${mediumSize}px;
    height: ${mediumSize}px;
  }

  @media (min-width: 1024px) {
    width: ${bigSize}px;
    height: ${bigSize}px;
  }
`

interface CircleAnimationProps {
  borderStrokeColor: string
  progress: number
  speed: number
  isPaused: boolean
}

const CircleAnimation = ({
  borderStrokeColor,
  progress,
  speed,
  isPaused,
}: CircleAnimationProps) => {
  const querySize = useMediaQuery(
    ['(min-width: 1024px)', '(min-width: 768px)', '(min-width: 320px)'],
    [bigSize, mediumSize, smallSize],
    smallSize
  )

  const [firstAnimVisible, setFirstAnimVisible] = useState(true)
  const onAnimEnd = () => {
    setFirstAnimVisible(false)
  }

  return (
    <Container>
      {firstAnimVisible && (
        <Rocket
          height={querySize}
          width={querySize}
          speed={speed}
          isPaused={isPaused}
          onAnimEnd={onAnimEnd}
        />
      )}
      {!firstAnimVisible && (
        <RocketInfinite
          height={querySize}
          width={querySize}
          speed={speed}
          isPaused={firstAnimVisible && isPaused}
        />
      )}
    </Container>
  )
}

export default CircleAnimation
